import NavigationService from '@lib/NavigationService'

export const navigationCreateGoal = () => {
  NavigationService.navigate('GoalSelectType')
}
